var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1253 7.50008C11.1253 7.1549 10.8455 6.87508 10.5003 6.87508C10.1551 6.87508 9.87533 7.1549 9.87533 7.50008L9.87533 9.3751H8.00033C7.65515 9.3751 7.37533 9.65492 7.37533 10.0001C7.37533 10.3453 7.65515 10.6251 8.00033 10.6251H9.87533V12.5001C9.87533 12.8453 10.1551 13.1251 10.5003 13.1251C10.8455 13.1251 11.1253 12.8453 11.1253 12.5001L11.1253 10.6251H13.0003C13.3455 10.6251 13.6253 10.3453 13.6253 10.0001C13.6253 9.65492 13.3455 9.3751 13.0003 9.3751H11.1253V7.50008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 1.04175C5.55277 1.04175 1.54199 5.05253 1.54199 10.0001C1.54199 14.9476 5.55277 18.9584 10.5003 18.9584C15.4479 18.9584 19.4587 14.9476 19.4587 10.0001C19.4587 5.05253 15.4479 1.04175 10.5003 1.04175ZM2.79199 10.0001C2.79199 5.74289 6.24313 2.29175 10.5003 2.29175C14.7575 2.29175 18.2087 5.74289 18.2087 10.0001C18.2087 14.2573 14.7575 17.7084 10.5003 17.7084C6.24313 17.7084 2.79199 14.2573 2.79199 10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circlePlus.23ef8e43e12ae1a6875ec17b02ec2260.svg";
export { ForwardRef as ReactComponent };